<app-dialog
  [isVisible]="isDialogVisible()"
  [settings]="{
    showHeader: false,
    closeOnEscape: true,
    isResizable: false,
    width: '320px',
  }"
  [emitOnHide]="true"
  (onHide)="handleDialogClose()"
>
  <div dialog-body>
    <form
      class="flex flex-column p-spacing-3xl gap-spacing-3xl radius-lg background-muted-secondary-bg"
      [formGroup]="form"
    >
      <div class="flex flex-column gap-spacing-3xl align-items-center">
        <div class="flex flex-column gap-spacing-2xl align-items-center">
          <label for="">Current User</label>
          <textarea
            rows="5"
            cols="30"
            pInputTextarea
            formControlName="userData"
          ></textarea>
        </div>
        <div class="flex flex-column gap-spacing-2xl align-items-center">
          <label for="">Locations IDs</label>
          <textarea
            rows="5"
            cols="30"
            pInputTextarea
            formControlName="locationsIds"
          ></textarea>
        </div>
        <div class="flex flex-column gap-spacing-2xl align-items-center">
          <label for="">Regions IDs</label>
          <textarea
            rows="5"
            cols="30"
            pInputTextarea
            formControlName="regionsIds"
          ></textarea>
        </div>
      </div>
      <div class="flex align-items-center justify-content-center">
        <app-button
          [label]="'Submit'"
          severity="primary"
          [outlinedButton]="true"
          [disabled]="!form.valid"
          (onClick)="submit()"
        />
      </div>
    </form>
  </div>
</app-dialog>
